module.exports = __webpack_public_path__ + "static/contact1-e22a1b158260c727b76368fce4977142.jpg";